// extracted by mini-css-extract-plugin
export var cardLayout = "_1s-1";
export var paginationContainer = "_1s-0";